import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { adminListEnquiries } from '../../api/packages';
import { formatINR } from '../../shared/data/common';
import AdminShell, { useAdminAccess } from './AdminShell';

export default function AdminEnquiriesPage() {
  const { auth } = useAuth();
  const hasAccess = useAdminAccess();
  const [pageData, setPageData] = useState(null);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);

  const load = useCallback(async () => {
    try {
      setError('');
      setPageData(await adminListEnquiries(auth.accessToken, page, 25));
    } catch (requestError) {
      setError(requestError.message);
    }
  }, [auth?.accessToken, page]);

  useEffect(() => {
    if (hasAccess) load();
  }, [hasAccess, load]);

  return (
    <AdminShell title="Package enquiries" subtitle="Quote requests sent by customers from package pages.">
      {error && <p className="api-message error" role="alert">{error}</p>}
      {!pageData && !error && <p role="status">Loading enquiries…</p>}
      {pageData && (
        <>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead><tr><th>Received</th><th>Package</th><th>Customer</th><th>Contact</th><th>Travel date</th><th>Travellers</th><th>Budget</th><th>Message</th></tr></thead>
              <tbody>
                {pageData.enquiries.map((e) => (
                  <tr key={e.id}>
                    <td>{new Date(e.createdAt).toLocaleString()}</td>
                    <td><Link className="link" to={`/admin/packages/${e.packageId}/edit`}>{e.packageTitle}</Link></td>
                    <td>{e.name}</td>
                    <td><a className="link" href={`mailto:${e.email}`}>{e.email}</a><br /><a href={`tel:${e.phone}`}>{e.phone}</a></td>
                    <td>{e.preferredDate || 'Flexible'}</td>
                    <td>{e.adults} adult{e.adults > 1 ? 's' : ''}{e.children ? `, ${e.children} child${e.children > 1 ? 'ren' : ''}` : ''}</td>
                    <td>{e.budget ? formatINR(e.budget) : '—'}</td>
                    <td className="admin-wrap">{e.message || '—'}</td>
                  </tr>
                ))}
                {!pageData.enquiries.length && <tr><td colSpan="8">No enquiries yet.</td></tr>}
              </tbody>
            </table>
          </div>
          <div className="admin-pagination">
            <span>{pageData.totalCount} enquiries</span>
            <button className="btn btn-outline btn-sm" disabled={page <= 1} onClick={() => setPage(page - 1)}>Previous</button>
            <span>Page {page}</span>
            <button className="btn btn-outline btn-sm" disabled={page * pageData.pageSize >= pageData.totalCount} onClick={() => setPage(page + 1)}>Next</button>
          </div>
        </>
      )}
    </AdminShell>
  );
}
